import cx from 'classnames'

type Props = {
  label: string
  score: number
  color: string
}

const ScoreBar = ({ label, score, color }: Props) => {
  const textColor =
    score >= 80
      ? 'text-green-700'
      : score >= 60
        ? 'text-amber-700'
        : 'text-red-700'

  return (
    <div
      className="flex items-center gap-2 py-1.5 px-2 bg-white rounded-md border-l-2"
      style={{ borderLeftColor: color }}
    >
      <span className="text-[10px] font-semibold text-coolGray-400 uppercase tracking-wide w-32 shrink-0">
        {label}
      </span>
      <div className="flex-1 h-1 bg-gold-100 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-700 ease-out"
          style={{ width: `${score}%`, backgroundColor: color }}
        />
      </div>
      <span className={cx('text-sm font-bold w-9 text-right', textColor)}>
        {score}%
      </span>
    </div>
  )
}

export default ScoreBar
